import { Box, TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { IFormInput } from '../../useEmergencyContact';

import { useSxStyles } from './useStyles';

type Props = {
  form: UseFormReturn<IFormInput>;
};

export const EmergencyContactEditMode = (props: Props) => {
  const {
    form: { control },
  } = props;

  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const commonFieldProps: Partial<TextFieldProps> = {
    size: 'small',
    fullWidth: true,
  };

  return (
    <Box sx={sxStyles.fieldSet}>
      <Controller
        control={control}
        name={'fEmpEmeName'}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              {...field}
              {...commonFieldProps}
              label={t('fEmpEmeName')}
              error={!!error?.message}
              helperText={error?.message}
              required={true}
            />
          );
        }}
      />
      <Controller
        control={control}
        name={'fEmpEmePhone'}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              {...field}
              {...commonFieldProps}
              label={t('fEmpEmePhone')}
              error={!!error?.message}
              helperText={error?.message}
            />
          );
        }}
      />
      <Controller
        control={control}
        name={'fEmpEmeEmail'}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              {...field}
              {...commonFieldProps}
              label={t('fEmpEmeEmail')}
              error={!!error?.message}
              helperText={error?.message}
            />
          );
        }}
      />
    </Box>
  );
};
